import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetMetaDataSlice } from "../../src/redux/features/MetaDataManagementSlice";
import { DeleteMetaDataSlice } from "../../src/redux/features/MetaDataManagementSlice";
import { useNavigate } from "react-router-dom";

const MetaData = ({ type }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();


    // ✅ CORRECT STATE PATH
    const { list, pagination, loading } = useSelector(
        (state) => state?.MetaDataManagement
    );

    const [page, setPage] = useState(1);
    const limit = 3;

    const handleEdit = (item) => {
        if (item.type === "CATEGORY") {
            navigate(
                `/MetadataManagement/CategoryMetaData/EditCatMetaData/${item._id}`
            );
        } else if (item.type === "SUBCATEGORY") {
            navigate(
                `/MetadataManagement/SubCategoryMetaData/EditSubCatMetaData/${item._id}`
            );
        }
    };


    /* Fetch Meta Data */
    useEffect(() => {
        dispatch(
            GetMetaDataSlice({
                type,
                page,
                limit,
            })
        );
    }, [dispatch, page, type]);


    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this meta data?")) {
            dispatch(DeleteMetaDataSlice(id));
        }
    };

    return (
        <div className="MetaDataPage">
            <div className="TableList">
                <table style={{ width: "100%" }}>
                    <thead>
                        <tr>
                            <th>Sr No</th>
                            <th>Category</th>
                            <th>Subcategory</th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Keywords</th>
                            <th>Created At</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {/* Loading */}
                        {loading && (
                            <tr>
                                <td colSpan={9} style={{ textAlign: "center" }}>
                                    Loading...
                                </td>
                            </tr>
                        )}

                        {/* Data */}
                        {!loading && list?.length > 0 &&
                            list?.map((item, index) => (
                                <tr key={item._id}>
                                    <td>{(page - 1) * limit + index + 1}</td>
                                    <td>{item?.categoryId?.categoryName || "-"}</td>
                                    <td>{item?.subcategoryId?.subcategoryName || "-"}</td>
                                    <td>{item?.title}</td>
                                    <td
                                        style={{
                                            maxWidth: "250px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                        title={item?.description}
                                    >
                                        {item?.description}
                                    </td>
                                    <td>{item?.keywords?.join(", ")}</td>
                                    <td>{item?.createdAt?.substring(0, 10)}</td>
                                    <td>
                                        <div className="action-icons">
                                            <i
                                                className="fa fa-pencil edit-icon"
                                                title="Edit"
                                                onClick={() => handleEdit(item)}
                                            />


                                            <i
                                                className="fa fa-trash delete-icon"
                                                title="Delete"
                                                onClick={() => handleDelete(item._id)}
                                            />

                                        </div>
                                    </td>

                                </tr>
                            ))}

                        {/* Empty */}
                        {!loading && list?.length === 0 && (
                            <tr>
                                <td colSpan={9} style={{ textAlign: "center" }}>
                                    No Meta Data Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {/* Pagination */}

                {pagination?.totalPages > 1 && (
                    <div className="pagination mt-3">
                        <button
                            disabled={page === 1}
                            onClick={() => setPage((prev) => prev - 1)}
                        >
                            Prev
                        </button>

                        {[...Array(pagination?.totalPages)].map((_, i) => (
                            <button
                                key={i}
                                className={page === i + 1 ? "active" : ""}
                                onClick={() => setPage(i + 1)}
                            >
                                {i + 1}
                            </button>
                        ))}

                        <button
                            disabled={page === pagination?.totalPages}
                            onClick={() => setPage((prev) => prev + 1)}
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MetaData;
